<app-dialog-header *ngIf="isDialog" headerIcon="information" headerText="Asset Information"
    (onCloseClick)="onCancelClick()"></app-dialog-header>
<div [ngClass]="!isDialog ? 'main-info-div' : 'dialog-div'">
    <div *ngIf="asset" class="info-columns alignColumn">
        <span style="font-weight: bolder;">Asset Type:</span>
        <ejs-dropdownlist class="dropdown" id="dropdown" #dropdown [dataSource]='assetTypes' [fields]="assetTypeFields"
            [value]="asset.Type" (change)="patchAssetType($event)" [readonly]="!canEdit">
            <ng-template #itemTemplate let-data>
                <div>
                    <span>{{ data.Type }}</span>
                </div>
            </ng-template>
        </ejs-dropdownlist>
    </div>
    <hr>
    <ejs-tab>
        <e-tabitems>
            <e-tabitem>
                <ng-template #headerText>
                    <span class="app-icon app-icon--text"><mat-icon />&nbsp;Text</span>
                </ng-template>
                <ng-template #content>
                    <!-- <div style="max-height: 70vh; overflow-y: auto;"> -->
                    <ng-container [ngTemplateOutlet]="textInformationTemplate"></ng-container>
                    <!-- </div> -->
                </ng-template>
            </e-tabitem>
            <e-tabitem>
                <ng-template #headerText>
                    <span class="app-icon app-icon--file"><mat-icon />&nbsp;Files</span>
                </ng-template>
                <ng-template #content>
                    <ng-container [ngTemplateOutlet]="fileInformationTemplate"></ng-container>
                </ng-template>
            </e-tabitem>
            <e-tabitem *ngIf="canEdit">
                <ng-template #headerText>
                    <span class="app-icon app-icon--add"><mat-icon />&nbsp;New</span>
                </ng-template>
                <ng-template #content>
                    <ng-container [ngTemplateOutlet]="addTextInformationTemplate"></ng-container>
                </ng-template>
            </e-tabitem>
        </e-tabitems>
    </ejs-tab>
</div>

<ng-template #textInformationTemplate>
    <ng-container *ngIf="useAccordions then accordions else list"></ng-container>
    <ng-template #accordions>
        <div class="info-accordions" *ngIf="assetInformation.length > 0">
            <ejs-accordion>
                <e-accordionitems>
                    <e-accordionitem *ngFor="let info of textInformation">
                        <ng-template #header>
                            <div class="header">
                                <u>{{info.Title}}</u>
                            </div>
                        </ng-template>
                        <ng-template #content>
                            <div class="info-meta">
                                <span>{{info.AddedByName}} - {{convertEpoch(info.AddedAt)}}</span>
                            </div>
                            <!-- <div class="info-content">{{info.Content}}</div> -->
                            <div class="info-delete alignRow">
                                <div class="info-content"
                                    [innerHTML]="info.Content?.replaceAll('<p>', '<span>')?.replaceAll('</p>', '</span>')">
                                </div>
                                <span class="delete">
                                    <button mat-icon-button matTooltip="Delete Asset Information"
                                        (click)="deleteAssetInformation(info)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </span>
                            </div>
                        </ng-template>
                    </e-accordionitem>
                </e-accordionitems>
            </ejs-accordion>
        </div>
    </ng-template>
    <ng-template #list>
        <div class="info-accordions" *ngIf="assetInformation.length > 0">
            <ng-container *ngFor="let info of textInformation">
                <div class="newInfo-delete alignRow">
                    <div class="newInfo">
                        <span class="newInfo-title alignColumn">{{info.Title}}</span>
                        <ejs-inplaceeditor #editor *ngIf="editingInformation == info.AssetInformationID" mode="Inline"
                            type="RTE" class="newInfo-content" [value]="info.Content" editableOn="EditIconClick"
                            showButtons="1" [enableEditMode]="true" (endEdit)="stopEditingInformation()"
                            (submitClick)="submitClick(editor.value, info)">
                        </ejs-inplaceeditor>
                        <span *ngIf="editingInformation != info.AssetInformationID" class="newInfo-content"
                            [innerHTML]="info.Content?.replaceAll('<p>', '<span>')?.replaceAll('</p>', '</span>')"></span>
                    </div>
                    <span>
                        <button *ngIf="editingInformation != info.AssetInformationID" mat-icon-button
                            matTooltip="Edit Asset Information"
                            (click)="startEditingInformation(info.AssetInformationID)">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button *ngIf="editingInformation == info.AssetInformationID" mat-icon-button
                            matTooltip="Stop Editing Information" (click)="stopEditingInformation()">
                            <mat-icon>edit_off</mat-icon>
                        </button>
                    </span>
                    <span class="newDelete">
                        <button mat-icon-button matTooltip="Delete Asset Information"
                            (click)="deleteAssetInformation(info)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </span>
                </div>
                <div class="newInfo-meta">
                    <span>{{info.AddedByName}} - {{convertEpoch(info.AddedAt)}}</span>
                </div>
            </ng-container>
        </div>
    </ng-template>
</ng-template>

<ng-template #fileInformationTemplate>
    <div class="info-title">
        <span>Title</span>
        <span>File</span>
    </div>
    <div *ngFor="let info of fileInformation" class="info-item alignRow">
        <span>{{info.Title}}</span>
        <span class="file-link" (click)="getFile(info.AssetInformationGUID, info.FileName!)" title="Open File">
            {{info.FileName}}</span>
        <span style="font-style: italic;">{{info.AddedByName}} - {{convertEpoch(info.AddedAt)}}</span>
        <span class="download-button">
            <button mat-icon-button title="Download File"
                (click)="getFile(info.AssetInformationGUID, info.FileName!, true)">
                <mat-icon>download</mat-icon>
            </button>
        </span>
        <span class="delete">
            <button mat-icon-button matTooltip="Delete Asset Information" (click)="deleteAssetInformation(info, true)">
                <mat-icon>delete</mat-icon>
            </button>
        </span>
    </div>
</ng-template>

<ng-template #addTextInformationTemplate>
    <div class="add-text">
        <mat-form-field appearance="fill">
            <mat-label>Title</mat-label>
            <input placeholder="Add a title" matInput autocomplete="off" [(ngModel)]="newInfoTitle"
                (change)="checkNewInfoValid()">
        </mat-form-field>
        <span>Insert text here.</span>
        <ejs-richtexteditor #richText [showCharCount]='true' [enableXhtml]='true' [enableTabKey]='true'
            (change)="checkNewInfoValid()" [(value)]="newInfoContent">
        </ejs-richtexteditor>
        <hr>
        <span>Or choose file to upload.</span>
        <ejs-uploader #upload [autoUpload]="true" (selected)="checkNewInfoValid()" (removing)="checkNewInfoValid()"
            [multiple]="false" [allowedExtensions]="allowedExtentions"></ejs-uploader>
        <div class="buttons">
            <button mat-raised-button [disabled]="!newInfoValid" (click)="submitNewInfo()">
                <span>Submit</span>
                <mat-icon>done</mat-icon>
            </button>
        </div>
    </div>
</ng-template>